// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account\"},{\"path\":\"/create\"},{\"path\":\"/projects\"},{\"path\":\"/subscription\"},{\"path\":\"/usage\"},{\"path\":\"/blog\"},{\"path\":\"/legal/privacy-policy\"},{\"path\":\"/legal/terms-of-service\"},{\"path\":\"/manager\"},{\"path\":\"/models\"},{\"path\":\"/models/klingsync\"},{\"path\":\"/models/latent-sync\"},{\"path\":\"/models/sync-v1-9\"},{\"path\":\"/pricing\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/showcase\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.9";import * as Sentry from "@sentry/nextjs"

if (process.env.NODE_ENV === "production") {
	const isManagerRoute =
		typeof window !== "undefined" &&
		window.location.pathname.startsWith("/manager")

	Sentry.init({
		dsn: isManagerRoute
			? undefined
			: "https://eeb8bef4ddf31481158441fc9ce9b598@o4509516995559424.ingest.us.sentry.io/4510055333429248",
		sendDefaultPii: true,

		integrations: isManagerRoute
			? []
			: [
					Sentry.replayIntegration({
						maskAllText: false,
						blockAllMedia: false
					})
				],

		tracesSampler(samplingContext) {
			if (samplingContext.name?.startsWith("/manager")) return 0
			return 1
		},

		enableLogs: !isManagerRoute,

		// Keep regular traffic cheap, then manually start full replays for
		// paid users and high purchase-intent flows from client components.
		replaysSessionSampleRate: 0.01,
		replaysOnErrorSampleRate: 1.0,

		debug: false
	})
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
